/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';

class Submit extends React.Component<{ caption: string; disabled: boolean }> {
    render() {
        return (
            <div className="form-input-container form-input-submit">
                <input
                    autoComplete="off"
                    type="submit"
                    className="apmui-button apmui-button-submit"
                    disabled={this.props.disabled}
                    value={this.props.caption}
                />
            </div>
        );
    }
}

export default Submit;
